import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import HelpfulIcon from 'mdi-react/ThumbsUpIcon';
import AlertIcon from 'mdi-react/BellIcon';
import ListIcon from 'mdi-react/HeartIcon';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated';

type Props = {
  year: number;
  style?: React.CSSProperties;
  className?: string;
};

const ShopReviewThankYou = ({ year, style, className }: Props) => {
  const { market, t, linkTo } = useContext(AppContext);
  const isAuthenticated = useIsAuthenticated();

  return (
    <div style={style} className={className}>
      <S.Title>{t('reviews', 'store.completed-title')}</S.Title>

      {!isAuthenticated && (
        <div>{t('reviews', 'store.completed-awaiting-verification')}</div>
      )}

      {market.shopOfTheYear?.year && (
        <S.Soty>
          <S.Image
            src={`${market.cdn}/g/store_of_the_year/${year}/${market.code}/award/main_award.png`}
            alt={t('campaigns', 'shop-of-the-year.title-with-year', {
              year,
            })}
            width={100}
          />

          <S.Text>
            <T domain="reviews">store.soty-info.md</T>
          </S.Text>

          <S.Link to={linkTo('shopOfTheYear')}>
            {t('reviews', 'store.completed-soty-link')}
          </S.Link>
        </S.Soty>
      )}

      {isAuthenticated ? (
        <>
          <S.Title>{t('reviews', 'store.completed-profile-title')}</S.Title>

          <S.Text>{t('reviews', 'store.completed-profile-text')}</S.Text>

          <S.Text>
            <HelpfulIcon size={16} />
            {t('reviews', 'store.completed-profile-helpful')}
          </S.Text>

          <S.Link to="/account/profile">
            {t('reviews', 'store.completed-profile-link')}
          </S.Link>
        </>
      ) : (
        <>
          <S.Title>{t('reviews', 'store.completed-create-account')}</S.Title>

          <S.Text>
            <AlertIcon size={16} />
            {t('reviews', 'store.completed-alerts')}
          </S.Text>
          <S.Text>
            <ListIcon size={16} />
            {t('reviews', 'store.completed-lists')}
          </S.Text>
          <S.Text>
            <HelpfulIcon size={16} />
            {t('reviews', 'store.completed-helpful-profile')}
          </S.Text>

          <S.Link to="/signup">
            {t('account', 'sign-in-promo.create-account-button')}
          </S.Link>
        </>
      )}
    </div>
  );
};

export default ShopReviewThankYou;
